import MeritoButton from '../../../components/common/MeritoButtons/MeritoButtons';
import styles from './FinanceStatement.module.scss';
import { IoMdAdd as AddIcon } from "react-icons/io";
import FinanceTable from './FinanceTable/FinanceTable';
import { useEffect, useMemo, useState } from 'react';
import { RestS } from '../../../rest/rest-service';
import { useNavigate, useOutletContext } from 'react-router';
import HeaderTitle from '../../../components/common/HeaderTitle';
import { useAppDispatch, useAppSelector } from '../../../redux/reduxHooks';
import pcColdStateImg from './../../../assets/images/PC.svg';
import noAccountsConnectedImg from './../../../assets/images/financeStatement/noAccountsConnected.svg';
import statementInProgressImg from './../../../assets/images/financeStatement/statementInProgress.svg'
import moment from 'moment';
import { fetchProductMissingCosts, getMissingCostItemsThunk, setRefreshFinanceStatement } from '../../../redux/financeStatement/financeStatement';
import CircularLoader from '../../../components/common/CircularLoader/CircularLoader';
import { FinanceStatementColdState, missingCostItemsInf, PcColdStates, pnlFormat } from '../../../interfaces/interfaces';
import { MdOutlinePersonAdd as EditAccessIcon } from 'react-icons/md'
import PcAccessModal from '../PcAccess/PcAccessModal';
import FinanceBanner from './FinanceTable/FinanceBanner';
import { RiAlertFill, RiCheckboxCircleFill } from 'react-icons/ri';
import { convertDateToString, getLocalUser } from '../../../components/functions/utilities';
import Banner from '../../../components/common/Banner/Banner';
import { SI_BANNER_KEYS, SI_PROMO_CONFIG_KEYS, isSIPromoEnabled } from '../../../constants/promotionKeys';
import { trackSIPromoShown, trackSIPromoDismissed, trackSIPromoButtonClicked } from '../../GSTReconciliation/siPromoAmplitude';


const FinanceStatement = () => {

    const [tableData, setTableData] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [statementColdState, setStatementColdState] = useState(null);
    const [openEditAccess, setOpenEditAcces] = useState(false);
    const [pnlFormatState, setPnlFormatState] = useState(null);
    const [showBanner, setShowBanner] = useState(false);
    // const [ missingProductDetails, setMissingProductDetails ] = useState({} as {
    //   productCount: number;
    //   missingCostCount: number;
    // });
    // const [ missingCostItems, setMissingCostItems ] = useState({
    //     items: [],
    //     missingCounts: 0,
    //     lastMonth: ''
    // } as missingCostItemsInf)

    enum BannerStatus {
        fetching = "FETCHING",
        costMissing = "COST_MISSING",
        costUpdated = "COST_UPDATED",
        completed = "completed"
    }
    const [bannerStatus, setBannerStatus] = useState<BannerStatus>(BannerStatus.fetching)


    const getFinanceStatementTableData = async (isLoading = true) => {
        try {

            const data: any = await RestS.getFinanceStatementTable();
            // console.log('data', data);
            setTableData(data);
            setStatementColdState(data?.coldState)
            setShowBanner(data?.showBanner)
            if (isLoading) setLoading(false);
        } catch (error) {
            // setLoading(false);
            console.log('error', error);
        }
    }
    const { setHeaderContent, resetHeaderContent } = useOutletContext<any>();
    const { connectionStatus } = useAppSelector((state) => state.connections);

    const { refreshFinanceStatement, missingCostItems, missingProductCosts } = useAppSelector((state) => state.financeStatement);
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(fetchProductMissingCosts())
        dispatch(getMissingCostItemsThunk())
    }, [])

    useEffect(() => {
        if (refreshFinanceStatement) {
            getFinanceStatementTableData(false);
            dispatch(setRefreshFinanceStatement(false));
        }
    }, [refreshFinanceStatement])


    useEffect(() => {
        // if(showBanner) {
        setHeaderContent(<FinanceBanner showBanner={showBanner} />)
        return resetHeaderContent;
    }, [showBanner]);

    useEffect(() => {
        (async () => {

            const response = await RestS.checkPcGetStarted();
            console.log('response', response);
            if (response?.coldState == PcColdStates.accessDenied) {
                navigate('/pnltracker', { replace: true })
            }
            await getFinanceStatementTableData(true);
            setLoading(false)
        })()
    }, []);

    const { siPromoConfig } = useAppSelector((state) => state.config);
    const showSIPnLBanner = getLocalUser()?.role !== 'Agency' && isSIPromoEnabled(siPromoConfig, SI_PROMO_CONFIG_KEYS.BANNER_PNL);

    useEffect(() => {
        if (showSIPnLBanner) {
            trackSIPromoShown("banner", SI_BANNER_KEYS.FINANCE, "pnl");
        }
    }, [showSIPnLBanner]);

    const calendarYear = useMemo(() => {
        // console.log('table data', tableData);
        if (tableData && tableData.months && tableData.months.length) {
            const allMonths = tableData.months;
            let startMonth = moment(allMonths[allMonths.length - 1], "MM-YYYY").format("YYYY");
            let endMonth = moment(allMonths[0], "MM-YYYY").format("YYYY");

            // console.log('startMonth', startMonth, 'endMonth', endMonth, 'allMonths', allMonths)
            if (startMonth == endMonth) {
                return `Last 12 Months (${moment(allMonths[allMonths.length - 1], "MM-YYYY").format("MMM")} - ${moment(allMonths[0], "MM-YYYY").format("MMM YYYY")})`
            } else {
                return `Last 12 Months (${moment(allMonths[allMonths.length - 1], "MM-YYYY").format("MMM YYYY")} - ${moment(allMonths[0], "MM-YYYY").format("MMM YYYY")})`
            }
        } else {
            return '';
        }
    }, [tableData]);

    const closeEditAccess = () => {
        setOpenEditAcces(false);
    }

    const handlePnlFormatChange = (newPnlFormat) => {
        setPnlFormatState(newPnlFormat);
    };

    useEffect(() => {
        if (missingProductCosts.status == 'FETCHING') {
            setBannerStatus(BannerStatus?.fetching)
        } else {
            const missingCount = (missingProductCosts?.missingCostCount ?? 0) + (missingCostItems?.missingCounts ?? 0)
            console.log('missingCount', missingCount)
            if (missingCount > 0) {
                setBannerStatus(BannerStatus.costMissing)
            } else {
                setBannerStatus(BannerStatus.costUpdated)
                setTimeout(() => {
                    setBannerStatus(BannerStatus.completed)
                }, 4050)
            }
        }
    }, [missingProductCosts])

    const getBannerComponent = () => {
        switch (bannerStatus) {
            case BannerStatus.fetching:
                return (
                    <div className={`${styles.costBanner} ${styles.reviewingCost}`}>
                        <CircularLoader />
                        <div>
                            <p>Reviewing Product Costs</p>
                        </div>
                    </div>
                )
            case BannerStatus.costMissing: {
                let missingLine = ''
                const monthYear = convertDateToString(missingCostItems?.lastMonth)
                if (missingProductCosts?.missingCostCount) {
                    missingLine = `Costs missing for ${missingProductCosts?.missingCostCount} ${missingProductCosts?.missingCostCount > 1 ? 'products' : 'product'}`
                    if (missingCostItems?.missingCounts) {
                        missingLine += ` and actual ${missingCostItems?.missingCounts > 1 ? 'values' : 'value'} missing for ${missingCostItems?.missingCounts} ${missingCostItems?.missingCounts > 1 ? 'items' : 'item'}`
                    }
                } else if (missingCostItems?.missingCounts) {
                    missingLine = `Actual ${missingCostItems?.missingCounts > 1 ? 'values' : 'value'} missing for ${missingCostItems?.missingCounts} ${missingCostItems?.missingCounts > 1 ? 'items' : 'item'}`
                }
                if (missingLine != '') {
                    missingLine += ` in ${monthYear}`
                }
                return (
                    <div className={`${styles.costBanner} ${styles.cogsMissingBanner}`}
                        onClick={() => navigate('/pnltracker/edit/product-costs?section=Cost of Goods Sold&costMissing=true')}
                    >
                        <RiAlertFill />
                        <div>
                            <p>{missingLine}</p>
                        </div>
                    </div>
                )
            }
            case BannerStatus.costUpdated:
                return (
                    <div className={`${styles.costBanner} ${styles.costUpdated}`}>
                        <RiCheckboxCircleFill />
                        <div>
                            <p>All costs are updated!</p>
                        </div>
                    </div>
                )
            default: return null
        }
    }

    return (
        <>
            {loading ?
                <div className={styles.loaderContainer}>
                    <CircularLoader />
                </div> :
                connectionStatus?.length ?
                    statementColdState == FinanceStatementColdState.statementInProgress ?
                        <div className={styles.coldState}>
                            <div className={styles.leftContainer}>
                                <img src={statementInProgressImg} />
                            </div>
                            <div className={styles.rightContainer}>
                                <div className={styles.heading}>Calculating Your Profits!</div>
                                <p>While you wait, you can view the Reports in your Workspaces.</p>
                                <div>
                                    <MeritoButton size='md' type='primary-1' btnText='Go to Workspaces' onClick={() => navigate('/Reports')} />
                                </div>
                            </div>
                        </div>
                        :
                        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', gap: '1rem' }}>
                            {showSIPnLBanner && (
                                <Banner
                                    id={SI_BANNER_KEYS.FINANCE}
                                    variant="purple"
                                    highlightText="Look Beyond the P&L. "
                                    message="Track supplier-led GST delays that impact liquidity."
                                    action={{ label: 'View', onClick: () => { trackSIPromoButtonClicked("View", "pnl_banner"); navigate('/supplier-intelligence'); } }}
                                    onDismiss={() => trackSIPromoDismissed("banner", SI_BANNER_KEYS.FINANCE, "pnl")}
                                />
                            )}
                        <div className={styles.financeMainContainer} style={{ flex: 1, minHeight: 0 }}>
                            <div className={styles.topContainer}>
                                <div className={styles.textContainer}>
                                    <div className={styles.calendarYear}>
                                        {calendarYear}
                                    </div>
                                    <div className={styles.currencyText}>
                                        {`in ${pnlFormatState == pnlFormat.lakhs ? "Lakhs" : "Thousands"} (₹)`}
                                    </div>
                                    {getBannerComponent()}
                                </div>
                                <div className={styles.rightContainer}>
                                    <MeritoButton onlyIcon={true} type='outline-dim' onClick={() => setOpenEditAcces(true)} icon={<EditAccessIcon />} />
                                    <MeritoButton onClick={() => {
                                        navigate('/pnltracker/edit/sales-channels')
                                    }} type='primary-1' size='md' btnText='Add Data' icon={<AddIcon />} />
                                </div>
                            </div>
                            <FinanceTable handlePnlFormatChange={handlePnlFormatChange} tableData={tableData} missingProductDetails={missingProductCosts} />


                        </div>
                        </div> :
                    <div className={styles.coldState}>
                        <div className={styles.leftContainer}>
                            <img src={noAccountsConnectedImg} />
                        </div>
                        <div className={styles.rightContainer}>
                            <div className={styles.heading}>Discover Your Profitability!</div>
                            <p>Connect your accounts to view your year-long profitability.</p>
                            <div>
                                <MeritoButton size='md' type='primary-1' btnText='Connect Account' onClick={() => navigate('/workspaceStore')} />
                            </div>
                        </div>
                    </div>

            }
            {openEditAccess ?
                <PcAccessModal closeForm={closeEditAccess} isOpen={openEditAccess} />
                : null}
        </>
    )
}

export default FinanceStatement;